import information from './recordFrom/information.vue';
import claimsInfo from './recordFrom/claimsInfo.vue';
import compensationInfo from './recordFrom/compensationInfo.vue';
import { claimsHomeDetail } from './request';
import { claimsDetail } from '@/views/examine/claimRecordManage/request';
import MailInfo from './recordFrom/mailInfo.vue';
// import refuse from './recordFrom/refuse.vue';
// refuse
export default {
  components: {
    information,
    claimsInfo,
    compensationInfo,
    MailInfo
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    claimsReviewId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      info: null
    };
  },
  created() {
    setTimeout(() => {
      console.log(this.type);
      if (this.type == 0 || this.type == 10) {
        claimsHomeDetail({
          claimsId: this.$route.params.id
        }).then(res => {
          this.info = res;
        });
      } else {
        claimsDetail({
          claimsReviewId: this.claimsReviewId
        }).then(res => {
          this.info = res;
        });
      }
    }, 400);
  },
  methods: {}
};